import { Col, TitleText, UtilityText } from '@policygenius/mortar';
import React from 'react';

import styles from './dynamic-form-wrapper.module.scss';
import { Props } from './types';

const DynamicFormWrapper: React.FC<Props> = ({ children, section, title, subtitle }) => (
  <Col push={{ medium: 2, large: 3 }} span={{ small: 4, medium: 8, large: 6 }}>
    <div className={styles.headerWrapper}>
      {section && (
        <UtilityText className={styles.section} size="small" color="secondary" weight="bold">
          {section}
        </UtilityText>
      )}
      {title && <TitleText className={styles.title}>{title}</TitleText>}
      {subtitle && <UtilityText className={styles.subtitle}>{subtitle}</UtilityText>}
    </div>
    {children}
  </Col>
);

export default DynamicFormWrapper;
